module.exports = __webpack_public_path__ + "56e5756b696615d6164a625e1bcb1a9e.woff";